import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'

const RemoveBlockButton = ({ onClick }) => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-end'
            }}
        >
            <Button
                style={{ marginBottom: 16 }}
                variant="outlined"
                color="secondary"
                onClick={onClick}
            >
                Remove block
            </Button>
        </div>
    )
}

RemoveBlockButton.propTypes = {
    onClick: PropTypes.func
}

export default RemoveBlockButton
